._ProgramOnboardingPageConfig_m6y2k_1 {
  padding-top: 20px;
}
._ProgramOnboardingPageConfig_m6y2k_1 ._save_m6y2k_4 {
  margin-right: 20px;
}